import { PhagesHostsList } from "./PhagesHostsList";
/*import { PhagesHostsShow } from "./PhagesHostsShow";
import { PhagesHostsCreate } from "./PhagesHostsCreate";
import { PhagesHostsEdit } from "./PhagesHostsEdit";
*/

export const phages_hosts = {
  list: PhagesHostsList,
  /* show: PhagesHostsShow,
   create: PhagesHostsCreate,
   edit: PhagesHostsEdit,*/
};
